export enum PlayerLeague {
  NFL = 'nfl',
  NCAA = 'ncaa',
}
